import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';

const importationsOutcomeKPIs = [{
  'name': 'Liquidaciones',
  'path': paths.LiquidationsList,
  'resource': resources.LiquidationsList,
  'scopes': [scopes.See],
  'icon': 'partSales',
}];

const importationsPartsTracking = [{
  'name': 'Tracking',
  'path': paths.PartsImportsTrackingDashboard,
  'resource': resources.PartsImportsTrackingDashboard,
  'scopes': [scopes.See, scopes.Edit],
  'icon': 'partSales',
}];

const getImportationsOutcomeOptions = (permissions) => {
  const options = [{
    'name': 'Gestión de KPI\'s',
    'options': filterByPermissions(permissions, importationsOutcomeKPIs),
  }];

  return options.filter((item) => item.options.length);
};

const getImportationsProcessOptions = (permissions) => {
  const options = [{
    'name': 'Repuestos',
    'options': filterByPermissions(permissions, importationsPartsTracking),
  }];

  return options.filter((item) => item.options.length);
};

export const getImportationsOptions = (permissions) => {
  const options = [
    {
      'name': 'Proceso',
      'options': getImportationsProcessOptions(permissions),
    },
    {
      'name': 'Salida',
      'options': getImportationsOutcomeOptions(permissions),
    },
  ];

  return options.filter((item) => item.options.length);
};

export const importationsOptions = [
  ...importationsOutcomeKPIs,
  ...importationsPartsTracking,
];
